import { request2, cognitoRequestService } from "@/utils/request";

import {
  ILoginData,
  IPinLoginData,
  ILoginWithTokenResponse,
  IRefreshTokenData,
} from "@/interfaces/_shared/auth";
import {
  ILoginGetResponse,
  IRefreshGetResponse,
} from "@/interfaces/responses/auth";

/**
 * Login user with email
 * Postman: `GET_user_token`
 */
export async function getUserToken(
  userData: ILoginData
): Promise<ILoginGetResponse> {
  const response = await cognitoRequestService({
    method: "post",
    url: "/signin",
    // auth-login counts only sign-ins that say they come from the POS (APPS-794);
    // the kiosk calls the same endpoint without a type.
    data: { ...userData, type: "POS" },
  });

  return response.data.data;
}

/**
 * Refresh user tokens => access_token, refresh_token and expires_in
 * Postman: `GET_user_token_refresh`
 */
// TODO igor: change request
export async function getRefreshUserTokens(
  userData: IRefreshTokenData
): Promise<IRefreshGetResponse> {
  const response = await cognitoRequestService({
    method: "post",
    url: "/refresh",
    data: userData,
  });

  return response.data.data;
}

export async function getIntercomUserToken(
  authToken: string
): Promise<IRefreshGetResponse> {
  const response = await cognitoRequestService({
    method: "post",
    url: "/intercom",
    headers: {
      Authorization: authToken,
    },
  });

  return response.data.data;
}

/**
 *
 * @param smtzToken which is access_token of the logged in user
 * @returns the token the user will use to query using GraphQl
 */
export async function loginWithSmtzToken(
  smtzToken: string
): Promise<ILoginWithTokenResponse> {
  const params = { smeetzToken: smtzToken };
  const response = await request2({
    method: "POST",
    url: "/api/v1/temp-auth/smeetz-boffice",
    data: { smeetzToken: smtzToken },
  });

  const data = response.data;
  return data;
}

/**
 * Login a POS Seller with a PIN code via the auth service.
 */
export async function loginWithPin(
  data: IPinLoginData
): Promise<ILoginGetResponse> {
  const response = await cognitoRequestService({
    method: "post",
    url: "/pos-signin",
    data,
  });

  return response.data.data;
}
